import React from 'react';
import { CtaButton } from './CtaButton';
import { Ornament } from './Ornament';
import { checkoutUrl, finalCta, offer } from '../data/content';
export function FinalCta() {
  return <section id="cierre" className="bg-cream-deep text-ink" data-id="element-72" data-mp="19eyyj49ferxy">
      <div className="mx-auto max-w-2xl px-5 py-20 text-center sm:px-6 lg:py-28" data-id="element-73" data-mp="19ga4naqcgbs8">
        <p className="font-display text-[1.7rem] font-semibold italic leading-snug text-brown sm:text-[2.2rem]" data-id="element-74" data-mp="15cklj0sfumel">
          {finalCta.quote}{' '}
          <span className="text-rose-deep" data-id="element-75" data-mp="1ee1xc6ytc1xh">{finalCta.quoteAccent}</span>
        </p>

        <Ornament className="mt-9" data-id="element-76" data-mp="1ebxrhjhcssuk" />

        <h2 className="mt-8 text-brown" data-id="element-77" data-mp="1t3g5jbqnkdba">
          <span className="block font-display text-xl font-semibold uppercase tracking-[0.22em]" data-id="element-78" data-mp="1t253bgcuvdma">Desafío</span>
          <span className="-mt-1 block font-script text-[3rem] leading-none text-rose sm:text-6xl" data-id="element-79" data-mp="1o5y6qe6cneh0">Mujer de</span>
          <span className="block font-display text-[2.2rem] font-semibold uppercase leading-none tracking-[0.04em] sm:text-5xl" data-id="element-80" data-mp="2219z4ex18sur">
            Proverbios 31
          </span>
        </h2>
        <p className="mx-auto mt-5 max-w-md font-sans text-[0.98rem] leading-relaxed text-ink-soft" data-id="element-81" data-mp="n7p6tg60bfku">
          {finalCta.description}
        </p>

        <p className="mt-8 font-sans text-xs font-bold uppercase tracking-[0.2em] text-gold-deep" data-id="element-82" data-mp="x3irjmtvqfdp">
          {finalCta.bundle}
        </p>
        <p className="mt-2 font-display text-[3.2rem] font-bold leading-none text-rose-deep sm:text-6xl" data-id="element-83" data-mp="1246gm2yjsm5a">
          {offer.price}
        </p>
        <p className="mt-2 font-sans text-xs font-bold uppercase tracking-[0.24em] text-brown" data-id="element-84" data-mp="1b3a0381mn3kb">{offer.note}</p>

        <div className="mx-auto mt-8 max-w-md" data-id="element-85" data-mp="1ftqfuysx719u">
          <CtaButton href={checkoutUrl} data-id="element-86" data-mp="1fv1r1jop3baz">{finalCta.cta}</CtaButton>
        </div>
      </div>
    </section>;
}